
import { Options, Vue } from 'vue-class-component'
import Employee from '@/employee/Employee'
import Farm from '@/farm/Farm'
import ValueMeter from '@/components/ui/ValueMeter.vue'
import TextButton from '@/components/ui/TextButton.vue'
import util from '@/util'
import ResearchThumb from "@/components/ResearchThumb.vue"

@Options({
  components: {
    ValueMeter, TextButton, ResearchThumb
  },
  props: {
    employee: Employee, farm: Farm
  },
  methods: {
    log(msg: any) {
      console.log(msg)
    },
    deltaSymbol(value: number): string {
      if (value > 0) return 'Increasing'
      else if (value < 0) return 'Decreasing'
      return 'Stable'
    }
  },
  computed: {
    cssVars() {
      return {
        '--background-image': 'url(' + require('@/assets/wolfgang-hasselmann.jpg') + ')'
      }
    },
    util() {
      return util
    }
  }
})
export default class EmployeeCard extends Vue {
  employee!: Employee
  farm!: Farm
}
